import { render } from "./StatisticsCostLimitView.vue?vue&type=template&id=30250a3d&scoped=true"
import script from "./StatisticsCostLimitView.vue?vue&type=script&lang=js"
export * from "./StatisticsCostLimitView.vue?vue&type=script&lang=js"

import "./StatisticsCostLimitView.vue?vue&type=style&index=0&id=30250a3d&scoped=true&lang=css"

import exportComponent from "/builds/swisscom/messaging/web-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30250a3d"]])

export default __exports__